import { makeAutoObservable } from 'mobx';
import { Timeline } from '../presentation-config-aggregate-types/presentation-config-aggregate-types';
import SequenceEntity from '../sequence-entity/sequence-entity';


class TimelineEntity {

  private sequences: SequenceEntity[];

  constructor (fromDTO: Timeline = {} as Timeline) {
    makeAutoObservable(this);
    this.deserialize(fromDTO);
  }

  public getSequences = (): SequenceEntity[] => {
    return this.sequences;
  };

  private deserialize = (fromDTO: Timeline): void => {
    this.sequences = fromDTO.sequences && fromDTO.sequences.sequence ?
      fromDTO.sequences.sequence.map(x => new SequenceEntity(x))
      : [new SequenceEntity()];
  };
}

export default TimelineEntity;
